const doc = document.documentElement;
const footer = document.querySelector("body > footer");
const checkScrolled = () => {
  if (footer.getBoundingClientRect().top < window.innerHeight) {
    document.body.classList.add("scroll-bottom");
  } else {
    document.body.classList.remove("scroll-bottom");
  }

  if (doc.scrollTop > window.innerHeight * 0.25) {
    document.body.classList.add("scrolled");
  } else {
    document.body.classList.remove("scrolled");
  }
};
window.addEventListener("scroll", () => checkScrolled());
checkScrolled();

document.querySelector("#top a").addEventListener("click", (evt) => {
  evt.preventDefault();
  window.scrollTo({ top: 0, behavior: "smooth" });
});

document.querySelectorAll(".scroll-panel").forEach((it) => {
  it.querySelector(".btn-previous").addEventListener("click", (evt) => {
    evt.preventDefault();
    evt.stopPropagation();
    const currentPage = parseInt(it.getAttribute("data-page"));
    const targetPage = currentPage == 0 ? 0 : currentPage - 1;
    it.setAttribute("data-page", targetPage.toString());
  });

  it.querySelector(".btn-next").addEventListener("click", (evt) => {
    evt.preventDefault();
    evt.stopPropagation();
    const maxPage = parseInt(it.getAttribute("data-max"));
    const currentPage = parseInt(it.getAttribute("data-page"));
    const targetPage = currentPage == maxPage ? maxPage : currentPage + 1;
    it.setAttribute("data-page", targetPage.toString());
  });
});

const inputState = JSON.parse(sessionStorage.getItem("input-state") || "{}");
document.querySelectorAll("input.local-storage-state").forEach((it) => {
  //restore state
  if (inputState[it.id] !== undefined) {
    if (
      it.getAttribute("type") === "checkbox" ||
      it.getAttribute("type") === "radio"
    ) {
      it.checked = inputState[it.id];
    } else {
      it.value = inputState[it.id];
    }
  }

  it.addEventListener("change", () => {
    inputState[it.id] = it.checked || it.value;
    sessionStorage.setItem("input-state", JSON.stringify(inputState));
  });
});

const zoom_control = document.querySelector('input#zoom');

if(zoom_control){
  zoom_control.addEventListener('change', ()=>{
    const ele = document.querySelector(".drag-scroll");
    const image = ele.querySelector("img");
    image.src = image.getAttribute('data-src');
    
    const clip = ele.getBoundingClientRect();

    ele.scrollTop = (ele.scrollHeight - clip.height) / 2;
    ele.scrollLeft = (ele.scrollWidth - clip.width) / 2;
  });
}

document.querySelectorAll(".drag-scroll").forEach((ele) => {
  ele.style.cursor = "grab";
  
  let pos = { top: 0, left: 0, x: 0, y: 0 };

  const mouseDownHandler = function (e) {
    e.preventDefault();
    ele.style.cursor = "grabbing";
    ele.style.userSelect = "none";

    pos = {
      left: ele.scrollLeft,
      top: ele.scrollTop,
      // Get the current mouse position
      x: e.clientX,
      y: e.clientY,
    };

    document.addEventListener("mousemove", mouseMoveHandler);
    document.addEventListener("mouseup", mouseUpHandler);
  };

  const mouseMoveHandler = (e) => {
    // How far the mouse has been moved
    const dx = e.clientX - pos.x;
    const dy = e.clientY - pos.y;

    // Scroll the element
    ele.scrollTop = pos.top - dy;
    ele.scrollLeft = pos.left - dx;
  };

  const mouseUpHandler = () => {
    ele.style.cursor = "grab";
    ele.style.removeProperty("user-select");

    document.removeEventListener("mousemove", mouseMoveHandler);
    document.removeEventListener("mouseup", mouseUpHandler);
  };

  // Attach the handler
  ele.addEventListener("mousedown", mouseDownHandler);
});

function getFlagEmoji(countryCode) {
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map(char =>  127397 + char.charCodeAt());
  return String.fromCodePoint(...codePoints);
}

window.getFlagEmoji = getFlagEmoji;


/*** 
search live update
**/

const inputSearch = document.getElementById('Search');
const divSearchResult = document.getElementById('search-results');
const searchLoading = document.getElementById('search-result-loading');
let tid = 0;
inputSearch.addEventListener('keyup', ()=>{
  searchLoading.setAttribute('checked', 'checked');

  clearTimeout(tid);
  tid = setTimeout(async ()=>{
    const request = await fetch('/search?view=fetch&q='+inputSearch.value);
    const text = await request.text();
    divSearchResult.innerHTML = text;
        searchLoading.removeAttribute('checked');
  }, 500)
})

/**
add utm code to cart attributes
**/
const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());
if(params.utm_source){
  const fd = new FormData();
  fd.append("attributes[utm_source]", params.utm_source);
  fd.append("attributes[utm_medium]", params.utm_medium);
  fd.append("attributes[utm_id]", params.utm_id  || "");
  fd.append("attributes[utm_campaign]", params.utm_campaign || "");
  fd.append("attributes[utm_term]", params.utm_term || "");
  fd.append("attributes[utm_content]", params.utm_content || "");

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    body: fd,
    credentials: "include"
  }).then(()=>{
    console.log('utm code added to cart attribute')
  });
}

/**
announcement bar rolling message
*/

setInterval(()=>{
  [...document.querySelectorAll('.rolling-message')].forEach(it=>{
    let page = parseInt(it.dataset.page) + 1;
    if(page >= it.dataset.max)page=0;
    it.dataset.page = page;
  })
}, 3000);

/**
NumberInput functionality for quantity inputs
Note: NumberInput class is now handled by the ES6 module in NumberInput.js
*/